import React from 'react'
// import { StaticQuery, graphql } from "gatsby"
// import Img from "gatsby-image"

// import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'
import { Box, Image } from 'grommet'
import UnisexIconWhite from '../../images/rtg/unisex-icon-white.png'
import MaleIconWhite from '../../images/rtg/male-icon-white.png'
import FemaleIconWhite from '../../images/rtg/female-icon-white.png'
import UnisexIconGrey from '../../images/rtg/unisex-icon-grey.png'
import MaleIconGrey from '../../images/rtg/male-icon-grey.png'
import FemaleIconGrey from '../../images/rtg/female-icon-grey.png'

const Container = styled(Box)`
  cursor: pointer;
  padding: 2px;
  border-color: ${props => props.border.color};
  &:focus,
  &:active {
    border-color: ${props => props.border.color};
  }
`

const iconsGender = {
  UnisexIconWhite: <Image src={UnisexIconWhite} alt="UnisexIconWhite" />,
  MaleIconWhite: <Image src={MaleIconWhite} alt="MaleIconWhite" />,
  FemaleIconWhite: <Image src={FemaleIconWhite} alt="FemaleIconWhite" />,
  UnisexIconGrey: <Image src={UnisexIconGrey} alt="UnisexIconGrey" />,
  MaleIconGrey: <Image src={MaleIconGrey} alt="MaleIconGrey" />,
  FemaleIconGrey: <Image src={FemaleIconGrey} alt="FemaleIconGrey" />,
}

const Icon = ({ size, name, active = false, clicked = null }) => {
  // const data = useStaticQuery(query)
  const iconName = active ? name + 'White' : name + 'Grey'

  let borderColor = '#9B9B9B'
  if (active) {
    switch (name) {
      case 'UnisexIcon':
        borderColor = '#B621F0'
        break
      case 'MaleIcon':
        borderColor = '#2984F0'
        break
      case 'FemaleIcon':
        borderColor = '#FC1845'
        break
    }
  }
  const imageSrc = iconsGender[iconName]
  return (
    <Container
      width={size}
      height={size}
      align="stretch"
      justify="center"
      round={true}
      border={{
        color: borderColor,
        size: '1px',
        style: 'solid',
        side: 'all',
      }}
      background={active ? borderColor : 'baseBackground'}
      onClick={clicked}
      tabIndex="-1"
    >
      {/* <Box
              flex={true}
              align="center"
              justify="center"
              round={true}
              onClick={clicked}
            > */}

      {/* <a> */}
      {imageSrc}
      {/* <GatsbyImage image={imageSrc} alt={iconName} /> */}
      {/* </a> */}

      {/* </Box> */}
    </Container>
  )
}

export default Icon
